import * as yup from 'yup'

import {
  currency,
  emailRequired,
  language,
  languageValidator,
  password,
  region,
  timezone,
} from '@/utils/validations/common/utils'

export const userLocaleHiddenSchema = yup.object({
  language: languageValidator,
  currency: currency(),
  region: region(),
  timezone: timezone().nullable().optional(),
})

export const userProfilePasswordSchema = yup.object({
  current_password: password(),
  new_password: password(),
  repeat_new_password: password().oneOf([yup.ref('new_password'), null], 'error-passwords-match'),
})

export const uploadFileSchema = yup.object({
  file: yup.mixed().required('Required'),
  type: yup.string().required('Required'),
})

export const setUserPasswordFormSchema = yup.object({
  password: password(),
  passwordCheck: yup
    .string()
    .test('passwords-match', 'set-password-error-not-match', function (value) {
      const {password} = this.parent
      return password === value
    }),
})

export const forgotUserPasswordSchema = yup.object({
  email: emailRequired,
  language: language(),
})

export const activateAccountSchema = yup.object({
  secret: yup.string().defined(),
})

export const initiateAccountFormSchema = yup.object({
  // TODO: can be added later when we decide we want to ask a new user for name too
  // first_name: yup.string().required('error-missing-name'),
  // last_name: yup.string().required('error-missing-surname'),
  first_name: yup.string().optional(),
  last_name: yup.string().optional(),
  password: password(),
  repeat_password: yup
    .string()
    .required('error-missing-password')
    .test('passwords-match', 'set-password-error-not-match', function (value) {
      const {password} = this.parent
      return password === value
    }),
})

export const initiateAccountSchema = yup.object({
  id: yup.string().required(),
  secretHash: yup.string().defined(),
  first_name: yup.string().optional(),
  last_name: yup.string().optional(),
  password: yup.string().optional(),
})

export type ForgotUserPasswordFields = yup.InferType<typeof forgotUserPasswordSchema>

export const loginByMagicLinkRequestSchema = yup.object({
  email: emailRequired,
  language: language(),
  callbackUrl: yup.string().optional(),
})

export type LoginByMagicLinkRequestFields = yup.InferType<typeof loginByMagicLinkRequestSchema>

export const loginByMagicLinkSchema = yup.object({
  email: yup.string().defined(),
  secretHash: yup.string().defined(),
})
